import { useState } from "react";
import { ChevronDown, ChevronUp, ExternalLink } from "lucide-react";
import { API } from "@/lib/config";

const HIDDEN = new Set(["id", "kind", "member_id", "applicant_id", "disclosure_version", "has_photo", "votes", "follows", "status", "created_at"]);
const label = (k) => k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
const fmt = (v) => (Array.isArray(v) ? v.join(", ") : v === "" || v == null ? "—" : String(v));

const TITLE = {
  captain: (r) => r.name,
  first_mate: (r) => r.name,
  yacht: (r) => `${r.boat_name} · ${r.owner_name}`,
  inquiry: (r) => `${r.boat_name} ← ${r.name}`,
};

export const RecordRow = ({ r, kind }) => {
  const [open, setOpen] = useState(false);
  const title = TITLE[kind]?.(r) || r.name;
  const fields = Object.entries(r).filter(([k]) => !HIDDEN.has(k));
  return (
    <li className="border border-[#D4AF37]/15 bg-[#0B111B] hover:border-[#D4AF37]/40 transition-colors" data-testid={`record-${r.id}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-4 px-4 md:px-6 py-4 text-left" data-testid={`record-toggle-${r.id}`}>
        <span className="min-w-0 flex-1">
          <span className="block font-display text-sm tracking-[0.06em] text-[#F5F3EF] truncate">{title}</span>
          <span className="block font-coords text-[9px] tracking-[0.2em] uppercase text-[#94A3B8] mt-1 truncate">
            {r.email} · {new Date(r.created_at).toLocaleString()}
          </span>
        </span>
        {kind !== "inquiry" && (
          <span className="hidden sm:block font-coords text-[10px] tracking-[0.2em] text-[#E8C15A]">★ {r.votes} · ⚭ {r.follows}</span>
        )}
        {open ? <ChevronUp size={16} className="text-[#D4AF37]" /> : <ChevronDown size={16} className="text-[#D4AF37]" />}
      </button>
      {open && (
        <dl className="grid sm:grid-cols-[180px_1fr] gap-x-6 gap-y-2 px-4 md:px-6 pb-5 pt-1 border-t border-[#D4AF37]/10 text-sm" data-testid={`record-detail-${r.id}`}>
          {fields.map(([k, v]) => (
            <div key={k} className="contents">
              <dt className="font-coords text-[9px] tracking-[0.2em] uppercase text-[#D4AF37] pt-1">{label(k)}</dt>
              <dd className="text-[#F5F3EF]/85 whitespace-pre-wrap break-words">{fmt(v)}</dd>
            </div>
          ))}
          {kind === "yacht" && r.has_photo && (
            <div className="contents">
              <dt className="font-coords text-[9px] tracking-[0.2em] uppercase text-[#D4AF37] pt-1">Transom Photo</dt>
              <dd>
                <a href={`${API}/applicants/${r.applicant_id}/photo`} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#E8C15A] hover:text-[#F3E08A] text-xs tracking-[0.15em] uppercase" data-testid={`record-photo-${r.id}`}>
                  Open photo <ExternalLink size={12} />
                </a>
              </dd>
            </div>
          )}
        </dl>
      )}
    </li>
  );
};
